// extracted by mini-css-extract-plugin
module.exports = {"slider-rail-height":"2px","slider-handle-size":"28px","container":"PriceRange-module--container--ac8aea"};